import PropTypes from 'prop-types';
import React, { useState, lazy, useEffect, useCallback, useRef, useMemo } from 'react';
import qs from 'qs';
import { LicenseManager } from 'ag-grid-enterprise';
import 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import bn from '../../../utils/bemnames';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { getTitle, history } from '../../../utils/navigation-util';
import DropdownList from '../DropdownList';
import TableFilter from '../TableFilter';
import { dateToNull, TokenDecodeForProductStatus } from '../../../utils/general-util';
import {
  distinctCounts,
  filters as defaultColumnTypes,
  loadingRenderer as defaultGridComponents,
  setNextGroupColumnText,
} from '../../../utils/AgGridFunctions';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { NUMBER_ZERO, NUMBER_ONE } from '../../../constants/NumberConstants';
import { FULL_USER } from '../../../constants/CompanyTrialTypeConstants';
import { DOWNLOADXLS } from '../../../constants/MessageConstans';
import ErrorBoundary from '../ErrorBoundary';
import TablePDF from '../TablePDF';
import api from '../../../api';
import { FE_ENV } from '../../../../frontend-env';
import { debugLog } from '../../../utils/debug-logger';
import { filterToDisplayedColumns } from './excelVisibleColumns';

const Card = lazy(() => import('../Card'));
const DESIRED_TABLE = FE_ENV.REACT_APP_DESIRED_TABLE ? FE_ENV.REACT_APP_DESIRED_TABLE : 'AgGrid';
const defaultAggFuncs = {
  'getNext-ColumnVal': setNextGroupColumnText,
  'count(Dist)': distinctCounts,
};
if (FE_ENV.REACT_APP_AGGRID_CREDENTIALS) {
  LicenseManager.setLicenseKey(FE_ENV.REACT_APP_AGGRID_CREDENTIALS);
}

const bem = bn.create('agGrid');

const normalizeColumnTypes = (type) => {
  if (type == null) return type;
  const normalizeType = (value) => (value === 'right-aligned' ? 'rightAligned' : value);
  return Array.isArray(type) ? type.map(normalizeType) : normalizeType(type);
};

const TableAgGridv31 = ({
  gridOptions,
  isComp = false,
  isInvest = false,
  IsShowCard = true,
  cancelSlideBottomToUp = false,
  title = '',
  smalltitle = '',
  gridOptionsFooter,
  addedClass = '',
  pageTitle = '',
  hideExcelDownloadIcon = false,
  isDropDown,
  isAllColumnOnExcel,
  DropDownSelection,
  handledChangedDDLValue,
  chartJSON,
  defaultWidthSetToAllColumns,
  showInfoLable,
  linebreakInfoLable,
  isHeaderInfoTooltip,
  extratitle = '',
  proposalDetail,
  setProposalDetails,
  appendData,
  isExpandAll,
  hideQuickFilter,
  isLandscape,
  isFullWidth,
  repeatedColIndex,
  limitedColumns,
  key,
  disableAutoHeightHeader = false,
}) => {
  const query = qs.parse(history.location.search, { ignoreQueryPrefix: true });
  const [serverButtonColour, setServerButtonColour] = useState(false);
  const [expandAll, setExpandAll] = useState(false);
  const defaultColDef = {
    editable: false,
    sortable: true,
    suppressHeaderMenuButton: true,
    resizable: true,
    flex: 1,
    cellDataType: false,
    floatingFilter: gridOptions.isfloatingFilter ? gridOptions.isfloatingFilter : null,
    cellClass: (params) => {
      if (params.data !== undefined) {
        if (params.data.TrialStatus) {
          return 'ag-cell-blurrytext';
        }
        if (params.data.TrialLog) {
          return 'ag-cell-blurrytext';
        }
        return '';
      }
    },
    cellClassRules: {
      even: function (params) {
        return Math.abs(Number(params.rowIndex) % 2) === NUMBER_ZERO;
      },
      odd: function (params) {
        return Math.abs(Number(params.rowIndex) % 2) === NUMBER_ONE;
      },
      'generic-search-highlight': function (params) {
        if (document.getElementById(`filter-text-box-${title.replaceAll(' ', '_')}`) === null) {
          return null;
        }
        return (
          document.getElementById(`filter-text-box-${title.replaceAll(' ', '_')}`).value !== '' &&
          params.value !== null &&
          params.value !== '' &&
          params.value !== undefined &&
          params.value
            .toString()
            .toLowerCase()
            .indexOf(
              document
                .getElementById(`filter-text-box-${title.replaceAll(' ', '_')}`)
                .value.toString()
                .toLowerCase(),
            ) > -1
        );
      },
    },
  };

  const defaultColDefFooter = {
    editable: false,
    sortable: true,
    suppressHeaderMenuButton: true,
    resizable: true,
    flex: 1,
    wrapText: true,
    autoHeight: true,
    cellDataType: false,
    floatingFilter: gridOptionsFooter === undefined ? false : gridOptionsFooter.isfloatingFilter,
    cellClass: (params) => {
      if (params.data !== undefined) {
        if (params.data.TrialStatus) {
          return 'ag-cell-blurrytext';
        }
        if (params.data.TrialLog) {
          return 'ag-cell-blurrytext';
        }
        return '';
      }
    },
    cellClassRules: {
      even: function (params) {
        return Math.abs(Number(params.rowIndex) % 2) === NUMBER_ZERO;
      },
      odd: function (params) {
        return Math.abs(Number(params.rowIndex) % 2) === NUMBER_ONE;
      },
    },
  };

  const { colDefsMedalsExcluded } = gridOptions;

  const setColumns = gridOptions.colDefsMedalsIncluded;
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const [gridApiFooter, setGridApiFooter] = useState(null);
  const [isHideShowBtn, setisHideShowBtn] = useState(true);
  const [isHideReturnShowBtn, setisHideReturnShowBtn] = useState(true);
  const [toggleExcludeColumns, setToggleExcludeColumns] = useState(true);
  const [chartRef, setChartRef] = useState(null);

  const topAgGrid = useRef(null);
  const FooterAgGrid = useRef(null);
  const gridContainerRef = useRef(null);
  const gridFooterContainerRef = useRef(null);

  const sanitizeColumnDefs = useCallback((colDefs) => {
    if (!Array.isArray(colDefs)) return colDefs;
    return colDefs.map((col) => {
      if (!col || typeof col !== 'object') return col;
      const { height, tyep, aggFuncs, cellRenderer1, ...rest } = col;

      if (tyep !== undefined && rest.type === undefined) {
        rest.type = tyep;
      }

      if (rest.type !== undefined) {
        rest.type = normalizeColumnTypes(rest.type);
      }

      if (cellRenderer1 !== undefined && rest.cellRenderer === undefined) {
        rest.cellRenderer = cellRenderer1;
      }

      if (aggFuncs !== undefined) {
        if (typeof aggFuncs === 'string' && rest.aggFunc === undefined) {
          rest.aggFunc = aggFuncs;
        } else if (Array.isArray(aggFuncs) && rest.allowedAggFuncs === undefined) {
          rest.allowedAggFuncs = aggFuncs;
        }
      }

      if (Array.isArray(rest.children)) {
        return { ...rest, children: sanitizeColumnDefs(rest.children) };
      }
      return rest;
    });
  }, []);

  const columnDefs = useMemo(
    () => sanitizeColumnDefs(gridOptions.colDefsMedalsIncluded),
    [gridOptions.colDefsMedalsIncluded, sanitizeColumnDefs],
  );
  const footerColumnDefs = useMemo(
    () => sanitizeColumnDefs(gridOptionsFooter?.colDefsMedalsIncluded),
    [gridOptionsFooter?.colDefsMedalsIncluded, sanitizeColumnDefs],
  );
  const shouldUseCacheBlockSize =
    gridOptions?.rowModelType === 'infinite' || gridOptions?.rowModelType === 'serverSide';

  const createDefaultGetRowId = useCallback(
    () => (params) => {
      const { data } = params;
      if (!data) return undefined;
      const preferredKeys = ['id', 'Id', 'ID', 'pid', 'PID', 'investor_id', 'Investor_Id', 'v_vuln_search.pid'];
      for (const key of preferredKeys) {
        const value = data[key];
        if (value != null && value !== '') return String(value);
      }
      for (const [key, value] of Object.entries(data)) {
        if (
          value != null &&
          typeof value !== 'object' &&
          (key === 'id' || key.endsWith('.pid') || key.endsWith('_id'))
        ) {
          return String(value);
        }
      }
      return undefined;
    },
    [],
  );

  const resolveGetRowId = useCallback(
    (options) =>
      options?.getRowId ??
      options?.getRowNodeId ??
      (options?.rowModelType === 'serverSide' ? createDefaultGetRowId() : undefined),
    [createDefaultGetRowId],
  );

  const getRowId = useMemo(() => resolveGetRowId(gridOptions), [gridOptions, resolveGetRowId]);
  const footerGetRowId = useMemo(() => resolveGetRowId(gridOptionsFooter), [gridOptionsFooter, resolveGetRowId]);

  const mainMaxBlocksInCache = useMemo(() => {
    if (gridOptions?.rowModelType === 'serverSide') return undefined;
    if (gridOptions.maxBlocksInCache != null) return gridOptions.maxBlocksInCache;
    if (gridOptions.HeaderGrouping) return 500;
    return undefined;
  }, [gridOptions?.rowModelType, gridOptions.maxBlocksInCache, gridOptions.HeaderGrouping]);

  const footerMaxBlocksInCache = useMemo(() => {
    if (gridOptionsFooter?.rowModelType === 'serverSide') return undefined;
    return gridOptionsFooter?.maxBlocksInCache;
  }, [gridOptionsFooter?.rowModelType, gridOptionsFooter?.maxBlocksInCache]);
  const gridColumnTypes = useMemo(
    () => ({
      ...defaultColumnTypes,
      ...(gridOptions.columnTypes || {}),
    }),
    [gridOptions.columnTypes],
  );
  const gridFooterColumnTypes = useMemo(
    () => ({
      ...defaultColumnTypes,
      ...(gridOptionsFooter?.columnTypes || {}),
    }),
    [gridOptionsFooter?.columnTypes],
  );
  const gridComponents = useMemo(
    () => ({
      ...defaultGridComponents,
      ...(gridOptions.components || {}),
    }),
    [gridOptions.components],
  );
  const gridFooterComponents = useMemo(
    () => ({
      ...defaultGridComponents,
      ...(gridOptionsFooter?.components || {}),
    }),
    [gridOptionsFooter?.components],
  );
  const pageAggFuncKeys = gridOptions.aggFuncs ? Object.keys(gridOptions.aggFuncs).sort().join(',') : '';
  const pageFooterAggFuncKeys = gridOptionsFooter?.aggFuncs
    ? Object.keys(gridOptionsFooter.aggFuncs).sort().join(',')
    : '';
  const gridAggFuncs = useMemo(() => {
    if (!pageAggFuncKeys) return defaultAggFuncs;
    return { ...defaultAggFuncs, ...gridOptions.aggFuncs };
    // Keys are stable across parent re-renders; function refs are module-level.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageAggFuncKeys]);
  const gridFooterAggFuncs = useMemo(() => {
    if (!pageFooterAggFuncKeys) return defaultAggFuncs;
    return { ...defaultAggFuncs, ...gridOptionsFooter.aggFuncs };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageFooterAggFuncKeys]);

  const createSafeGetRowHeight = useCallback((getRowHeight) => {
    if (!getRowHeight) return undefined;
    return (params) => {
      const height = getRowHeight(params);
      return height === 0 ? 1 : height;
    };
  }, []);

  const safeGetRowHeight = useMemo(
    () => createSafeGetRowHeight(gridOptions.getRowHeight),
    [createSafeGetRowHeight, gridOptions.getRowHeight],
  );
  const safeFooterGetRowHeight = useMemo(
    () => createSafeGetRowHeight(gridOptionsFooter?.getRowHeight),
    [createSafeGetRowHeight, gridOptionsFooter?.getRowHeight],
  );

  const getGridBodyWidth = (container) => {
    if (!container) return 0;
    const bodyViewport = container.querySelector('.ag-body-viewport');
    return bodyViewport?.clientWidth ?? 0;
  };

  const sizeColumnsToFitSafely = useCallback((api, containerRef) => {
    if (!api || api.isDestroyed?.()) return;
    if (getGridBodyWidth(containerRef?.current) <= 0) return;
    api.sizeColumnsToFit();
  }, []);

  const allColumnBtn = document.getElementById('showAllColumn');
  const returnDataBtn = document.getElementById('showReturnData');

  const onFirstDataRendered = () => {
    if (defaultWidthSetToAllColumns !== undefined && defaultWidthSetToAllColumns) {
      autoSizeAll(true);
    }
  };
  const onFirstDataRenderedFooter = () => {
    if (!query.print) {
      sizeColumnsToFitSafely(gridApiFooter, gridFooterContainerRef);
    }
  };

  const getChartToolbarItems = () => ['chartDownload', 'chartData', 'chartSettings'];

  function isExternalFilterPresent(params) {
    if (params !== undefined) {
      const newVal = gridOptions.isExternalFilterPresent;
      if (newVal !== undefined) {
        //gridApi.refreshServerSide({ purge: true });
      }
    }
  }

  function autoSizeAll(skipHeader) {
    const allColumnIds = [];
    gridColumnApi.getAllColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  const onGridSizeChanged = () => {
    sizeColumnsToFitSafely(gridApi, gridContainerRef);
  };
  const onGridSizeChangedFooter = () => {
    sizeColumnsToFitSafely(gridApiFooter, gridFooterContainerRef);
  };
  function headerHeightGetter() {
    const columnHeaderTexts = [...document.querySelectorAll('.ag-header-cell-text')];
    const clientHeights = columnHeaderTexts.map((headerText) => headerText.clientHeight);
    const tallestHeaderTextHeight = Math.max(...clientHeights);

    return tallestHeaderTextHeight;
  }

  function headerHeightSetter() {
    const padding = 20;
    const defaultHeight = 30;
    let height = 0;
    if (gridOptions.headerHeight === undefined && !disableAutoHeightHeader) {
      const autoHeight = headerHeightGetter();
      height = (autoHeight > defaultHeight ? autoHeight : defaultHeight) + padding / 2;
    } else if (
      gridOptions.headerHeight !== undefined ||
      gridOptions.headerHeight === null ||
      gridOptions.headerHeight === 0
    ) {
      height = gridOptions.headerHeight;
    } else {
      const gridheaderHeight = gridOptions.headerHeight !== undefined ? gridOptions.headerHeight : defaultHeight;
      height = gridheaderHeight + padding;
    }
    if (gridApi?.setGridOption) {
      gridApi.setGridOption('headerHeight', height);
    } else {
      gridApi?.setHeaderHeight(height);
    }
    return height;
  }
  function sortAndFilter(allOfTheData, sortModel, filterModel) {
    return sortData(sortModel, filterData(filterModel, allOfTheData));
  }
  function sortData(sortModel, data) {
    const sortPresent = sortModel && sortModel.length > 0;
    if (!sortPresent) {
      return data;
    }
    const resultOfSort = data?.slice();
    resultOfSort.sort((a, b) => {
      for (let k = 0; k < sortModel.length; k += 1) {
        const sortColModel = sortModel[k];
        const valueA = a[sortColModel.colId];
        const valueB = b[sortColModel.colId];
        const sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
        if (valueA > valueB) {
          return sortDirection;
        }
        return sortDirection * -1;
      }
      return 0;
    });
    return resultOfSort;
  }
  function filterData(filterModel, data) {
    const filterPresent = filterModel && Object.keys(filterModel).length > 0;
    if (!filterPresent) {
      return data;
    }
    const resultOfFilter = [];
    for (let i = 0; i < data.length; i += 1) {
      const item = data[i];
      if (filterModel.age) {
        const { age } = item;
        const allowedAge = Number(filterModel.age.filter);
        if (filterModel.age.type === 'equals') {
          if (age !== allowedAge) {
            continue;
          }
        } else if (filterModel.age.type === 'lessThan') {
          if (age >= allowedAge) {
            continue;
          }
        } else if (age <= allowedAge) {
          continue;
        }
      }
      if (filterModel.year) {
        if (filterModel.year.values.indexOf(item.year.toString()) < 0) {
          continue;
        }
      }
      if (filterModel.country) {
        if (filterModel.country.values.indexOf(item.country) < 0) {
          continue;
        }
      }
      resultOfFilter.push(item);
    }
    return resultOfFilter;
  }

  const [gridParams, setGridParams] = useState(null);

  const onGridReady = (params) => {
    debugLog('AgGrid', 'onGridReady', { title });
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    setGridParams(params);
    if (params.api?.setGridOption) {
      params.api.setGridOption('columnTypes', gridColumnTypes);
    }
    if (params.api && typeof params.api.hideOverlay === 'function') {
      params.api.hideOverlay();
      const nextHeaderHeight = headerHeightSetter();
      if (params.api?.setGridOption) {
        params.api.setGridOption('headerHeight', nextHeaderHeight);
      } else {
        params.api.setHeaderHeight(nextHeaderHeight);
      }
    }
  };

  const updateRowData = useCallback(
    (params) => {
      if (!params.api) return;
      params.api.refreshHeader();
      params.api.refreshCells({ force: true });
      if (query.print) {
        params.api.forEachNode((node) => {
          node.setExpanded(true);
        });
        const eGridDiv = gridContainerRef.current;
        eGridDiv.style.width = '';
        eGridDiv.style.height = '';
        params.api.setDomLayout('print');
      } else {
        if (gridOptions?.rowModelType === 'infinite') {
          const updateData = async () => {
            const status = gridOptions.serversideProduct
              ? await TokenDecodeForProductStatus(gridOptions.serversideProduct)
              : FULL_USER;
            api
              .post(gridOptions.serverSideRoute, {
                ...params.request,
                serverSideTables: gridOptions.serverSideTables,
                refreshButton: gridOptions.refreshServer,
                dataContextFilter: gridOptions.dataContextFilter,
                status: status,
              })
              .then((response) => {
                const { data } = response;
                // give each row an id
                data.data.forEach((d, index) => {
                  d.id = `R${index + 1}`;
                });
                const dataSource = {
                  rowCount: undefined,
                  getRows: (params) => {
                    for (const [key] of Object.entries(params.request.filterModel)) {
                      let isInline = true;
                      if (
                        gridOptions.serverSideNotInline !== undefined &&
                        gridOptions.serverSideNotInline.includes(key)
                      ) {
                        isInline = false;
                      }
                      params.request.filterModel[key] = {
                        ...params.request.filterModel[key],
                        isInline,
                      };
                    }
                    const dataAfterSortingAndFiltering = sortAndFilter(data, params.sortModel, params.filterModel);
                    const rowsThisPage = dataAfterSortingAndFiltering?.slice(params.startRow, params.endRow);
                    let lastRow = -1;
                    if (dataAfterSortingAndFiltering.length <= params.endRow) {
                      lastRow = dataAfterSortingAndFiltering.length;
                    }
                    params.successCallback(rowsThisPage, lastRow);
                  },
                };
                params.api.setGridOption('datasource', dataSource);
              });
          };
          updateData();
        }
      }
      if (gridOptions?.rowModelType === 'serverSide') {
        const updateData = () => {
          let datasource = {};
          datasource = {
            async getRows(params) {
              const a = params.api.getAllDisplayedColumns();
              const checkedRows = params.request.valueCols.map((request) => {
                let isShown = false;
                a.forEach((column) => {
                  if (request.id === column.colId) {
                    isShown = true;
                  }
                });
                return { ...request, isShown };
              });
              for (const [key] of Object.entries(params.request.filterModel)) {
                let isInline = true;
                if (gridOptions.serverSideNotInline !== undefined && gridOptions.serverSideNotInline.includes(key)) {
                  isInline = false;
                }
                params.request.filterModel[key] = {
                  ...params.request.filterModel[key],
                  isInline,
                };
              }
              params.request.valueCols = checkedRows;
              const status = gridOptions.serversideProduct
                ? await TokenDecodeForProductStatus(gridOptions.serversideProduct)
                : FULL_USER;
              api
                .post(gridOptions.serverSideRoute, {
                  ...params.request,
                  serverSideTables: gridOptions.serverSideTables,
                  refreshButton: gridOptions.refreshServer,
                  dataContextFilter: gridOptions.dataContextFilter,
                  status: status,
                })
                .then((response) => {
                  const { data } = response;
                  params.success({
                    rowData: data.rows.recordset,
                    endRow: data.rows.recordset.length - 1,
                  });
                })
                .catch((error) => {
                  params.fail();
                });
            },
          };
          params.api.setGridOption('serverSideDatasource', datasource);
        };
        updateData();
      }
      setTimeout(() => {
        sizeColumnsToFitSafely(params.api, gridContainerRef);
      }, 800);
    },
    [sizeColumnsToFitSafely],
  );

  useEffect(() => {
    debugLog('AgGrid', 'component mounted', { title, rowModelType: gridOptions?.rowModelType });
    return () => debugLog('AgGrid', 'component unmounted', { title });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (gridOptions?.rowModelType === 'serverSide' && gridParams) {
      updateRowData(gridParams);
    }
  }, [gridParams]);

  useEffect(() => {
    if (gridOptions.inVisibleColumns && gridOptions.inVisibleColumns !== undefined && gridColumnApi !== null) {
      gridColumnApi.setColumnsVisible(gridOptions.inVisibleColumns, false);
    }
  }, [gridColumnApi, gridOptions.inVisibleColumns]);

  useEffect(() => {
    if (gridApi?.setGridOption) {
      gridApi.setGridOption('columnTypes', gridColumnTypes);
    }
  }, [gridApi, gridColumnTypes]);

  useEffect(() => {
    if (gridApiFooter?.setGridOption) {
      gridApiFooter.setGridOption('columnTypes', gridFooterColumnTypes);
    }
  }, [gridApiFooter, gridFooterColumnTypes]);

  const listener = (event) => {
    setServerButtonColour(true);
  };

  useEffect(() => {
    gridApi ? gridApi.addEventListener('filterChanged', listener) : null;
    gridApi ? gridApi.addEventListener('columnVisible', listener) : null;
    document.getElementById('setCustomFilter') &&
      document.getElementById('setCustomFilter').addEventListener('click', listener);
    document.getElementById('clearCustomFilter') &&
      document.getElementById('clearCustomFilter').addEventListener('click', listener);
  }, []);

  const onGridReadyFooter = (params) => {
    setGridApiFooter(params.api);
    if (params.api?.setGridOption) {
      params.api.setGridOption('columnTypes', gridFooterColumnTypes);
    }

    params.api.refreshCells({ force: true });
    if (query.print) {
      const eGridDiv = gridFooterContainerRef.current;
      eGridDiv.style.width = '';
      eGridDiv.style.height = '';
      params.api.setDomLayout('print');
    } else {
      if (gridOptionsFooter?.rowModelType === 'infinite') {
        const updateData = (data) => {
          const dataSource = {
            rowCount: null,
            getRows(params) {
              const dataAfterSortingAndFiltering = sortAndFilter(data, params.sortModel, params.filterModel);
              const rowsThisPage = dataAfterSortingAndFiltering?.slice(params.startRow, params.endRow);
              let lastRow = -1;
              if (dataAfterSortingAndFiltering.length <= params.endRow) {
                lastRow = dataAfterSortingAndFiltering.length;
              }
              params.successCallback(rowsThisPage, lastRow);
            },
          };
          if (gridOptions?.rowModelType === 'infinite') {
            params.api.setGridOption('datasource', dataSource);
          } else {
            params.api.setDatasource(dataSource);
          }
        };
        updateData(gridOptionsFooter.rowData);
        params.api.refreshCells({ force: true });
      }
      if (gridOptionsFooter?.rowModelType === 'serverSide') {
        const updateData = (data) => {
          const fakeServer = createFakeServer(data);
          const datasource = createServerSideDatasource(fakeServer);
          params.api.setGridOption('serverSideDatasource', datasource);
        };
        updateData(gridOptionsFooter.rowData);
        params.api.refreshCells({ force: true });
      }
    }
  };
  const updateRowExpanded = () => {
    setExpandAll(!expandAll);
  };
  useEffect(() => {
    gridApi &&
      gridApi.forEachNode((node) => {
        node.expanded = expandAll;
      });
    gridApi && gridOptionsFooter?.rowModelType !== 'infinite' && gridApi.onGroupExpandedOrCollapsed();
  }, [expandAll]);

  function createServerSideDatasource(server) {
    return {
      getRows(params) {
        const response = server.getData(params.request);
        setTimeout(() => {
          if (response.success) {
            params.success({ rowData: response.rows });
          } else {
            params.fail();
          }
        }, 500);
      },
    };
  }
  function createFakeServer(allData) {
    return {
      getData(request) {
        const requestedRows = allData?.slice(request.startRow, request.endRow);
        const lastRow = getLastRowIndex(request, requestedRows);
        return {
          success: true,
          rows: requestedRows,
          lastRow,
        };
      },
    };
  }
  function getLastRowIndex(request, results) {
    if (!results) return undefined;
    const currentLastRow = request.startRow + results.length;
    return currentLastRow < request.endRow ? currentLastRow : undefined;
  }

  const onBtExcludeMedalColumns = () => {
    setColumns(colDefsMedalsExcluded);
    setToggleExcludeColumns(false);
  };
  const onBtIncludeMedalColumns = () => {
    setColumns(gridOptions.colDefsMedalsIncluded);
    setToggleExcludeColumns(true);
  };

  const ChartParams = (chartState, ChartType, titleText) => {
    if (!gridApi) return;
    allColumnBtn.setAttribute('disabled', 'disabled');
    returnDataBtn.setAttribute('disabled', 'disabled');
    allColumnBtn.style.visibility = 'hidden';
    returnDataBtn.style.visibility = 'hidden';
    if (chartJSON !== undefined && chartJSON.length > 0) {
      gridApi.setGridOption('rowData', chartJSON);
    }
    gridApi.onFilterChanged();
    gridApi.resetColumnState();
    gridApi.applyColumnState({
      state: chartState,
      defaultState: {
        pivot: false,
        rowGroup: false,
      },
    });

    const params = {
      chartType: ChartType,
      chartThemeName: 'ag-default',
      chartContainer: document.querySelector('#myChart'),
      processChartOptions: (params) => {
        const option = params.options;
        if (ChartType !== 'groupedColumn') {
          option.yAxis.label.formatter = function (params) {
            return `${params.value} %`;
          };
        }
        return option;
      },
      chartThemeOverrides: {
        common: {
          title: {
            enabled: true,
            text: titleText,
          },
          tooltip: {
            renderer: function (params) {
              return {
                content: `<b>${params.xName.toUpperCase()}:</b>${
                  params.xValue
                } <br/><b>${params.yName.toUpperCase()}:</b>${params.yValue}`,
              };
            },
          },
          legend: {
            enabled: true,
          },
        },

        bar: {
          series: {
            tooltip: {
              renderer: function (params) {
                return {
                  content: `<b>${params.xName.toUpperCase()}:</b>${
                    params.xValue
                  } <br/><b>${params.yName.toUpperCase()}:</b>${params.yValue}`,
                };
              },
            },
          },
        },
      },
    };

    setChartRef(gridApi.createPivotChart(params));

    if (document.getElementById('chartArea') !== null) {
      document.getElementById('chartArea').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  };

  const handleDropDown = (e) => {
    if (chartRef !== null) {
      chartRef.destroyChart();
    }
    if (e.value.toString() === '0') {
      allColumnBtn.removeAttribute('disabled');
      returnDataBtn.removeAttribute('disabled');
      allColumnBtn.style.visibility = 'visible';
      returnDataBtn.style.visibility = 'visible';
      gridApi.onFilterChanged();
      gridColumnApi.setPivotMode(false);
      if (chartJSON !== undefined && chartJSON.length > 0) {
        gridApi.setGridOption('rowData', gridOptions.rowData);
      }
      gridApi.applyColumnState({
        defaultState: {
          pivot: false,
          rowGroup: false,
        },
      });
    } else if (e.value.toString() === '2') {
      const state = [
        {
          colId: 'Year_action',
          rowGroup: true,
          chartDataType: 'category',
        },
        {
          colId: 'activist_name',
          chartDataType: 'series',
          aggFunc: 'count(Dist)',
        },
      ];
      ChartParams(state, 'groupedColumn', 'Number of short sellers publicly subjecting companies to allegations');
    } else if (e.value.toString() === '1') {
      const state = [
        {
          colId: 'Year_action',
          rowGroup: true,
        },
        {
          colId: 'company_name',
          aggFunc: 'count(Dist)',
        },
      ];
      ChartParams(state, 'groupedColumn', 'Number of companies publicly subjected to short sellers allegations');
    } else if (e.value.toString() === '3') {
      const state = [
        {
          colId: 'Year_action',
          rowGroup: true,
        },
        {
          colId: 'industry_sector_name',
          aggFunc: 'count',
          rowGroup: true,
          pivot: true,
        },
      ];
      ChartParams(
        state,
        'normalizedColumn',
        'Industry sectors of companies publicly subjected to short sellers allegations (%)',
      );
    } else if (e.value.toString() === '4') {
      const state = [
        {
          colId: 'Year_action',
          rowGroup: true,
        },
        {
          colId: 'company_name',
          aggFunc: 'count',
          chartDataType: 'series',
        },
        {
          colId: 'market_cap_category',
          rowGroup: true,
          pivot: true,
          chartDataType: 'series',
        },
      ];
      ChartParams(state, 'normalizedColumn', 'Market caps of companies publicly subjected to short seller allegations');
    }
  };
  useEffect(() => {
    sizeColumnsToFitSafely(gridApi, gridContainerRef);
  }, [proposalDetail, gridApi, query.meetingid, sizeColumnsToFitSafely]);

  const onBtColReturnHide = () => {
    setisHideReturnShowBtn(false);
    if (!isHideShowBtn) {
      setProposalDetails && setProposalDetails(true);
    }
  };

  const onBtColReturnShow = () => {
    setisHideReturnShowBtn(true);
  };

  useEffect(() => {
    if (gridApi && gridOptions) {
      const columnsToHide = gridOptions.hideColumns && gridOptions.hideColumns.columns;
      const columnsToShow = gridOptions.showColumns && gridOptions.showColumns.columns;
      if (isHideShowBtn) {
        gridApi.applyColumnState({ state: columnsToShow });
      } else {
        gridApi.applyColumnState({ state: columnsToHide });
      }
      sizeColumnsToFitSafely(gridApi, gridContainerRef);
    }
  }, [isHideShowBtn, gridApi, gridOptions, sizeColumnsToFitSafely]);

  useEffect(() => {
    if (gridApi && gridOptions) {
      const columnsToHide = gridOptions.hideReturnColumns && gridOptions.hideReturnColumns.columns;
      const columnsToShow = gridOptions.showReturnColumns && gridOptions.showReturnColumns.columns;
      if (isHideReturnShowBtn) {
        gridApi.applyColumnState({ state: columnsToShow });
      } else {
        gridApi.applyColumnState({ state: columnsToHide });
      }
      sizeColumnsToFitSafely(gridApi, gridContainerRef);
    }
  }, [isHideReturnShowBtn, gridApi, gridOptions, sizeColumnsToFitSafely]);

  const toggleShowHideColumns = () => {
    setisHideShowBtn(!isHideShowBtn);
  };
  const onFilterTextBoxChanged = () => {
    gridApi.setQuickFilter(document.getElementById(`filter-text-box-${title.replaceAll(' ', '_')}`).value);
    gridApi.refreshCells();
  };

  const customSearch = document.getElementById('filter_search_custom');
  const custonClear = document.getElementById('filter_clear_custom');
  customSearch &&
    customSearch.addEventListener('click', () => {
      gridApi &&
        gridApi.setQuickFilter(
          document.getElementById('filter-text-box-Voting_Rationale') &&
            document.getElementById('filter-text-box-Voting_Rationale').value,
        );
      gridApi &&
        gridApi.setQuickFilter(
          document.getElementById('filter-text-box-Vote_Details') &&
            document.getElementById('filter-text-box-Vote_Details').value,
        );
      gridApi && gridApi.refreshCells();
    });

  custonClear &&
    custonClear.addEventListener('click', () => {
      if (document.getElementById('filter-text-box-Voting_Rationale')) {
        document.getElementById('filter-text-box-Voting_Rationale').value = '';
      }
      if (document.getElementById('filter-text-box-Vote_Details')) {
        document.getElementById('filter-text-box-Vote_Details').value = '';
      }
      gridApi && gridApi.setQuickFilter('');
      gridApi && gridApi.refreshCells();
      gridApi && gridApi.setFilterModel(null);
      gridApi && gridApi.onFilterChanged();
    });

  const onMasterDetailFilterTextBoxChanged = () => {
    const toFilterBy = document.getElementById(`filter-text-box-${title.replaceAll(' ', '_')}`).value;
    let existsInMaster = false;
    gridApi.forEachNode((node) => {
      if (node.data.investor_name.includes(toFilterBy)) existsInMaster = true;
    });

    if (toFilterBy === '') {
      gridApi.setFilterModel(null);
      gridApi.forEachDetailGridInfo((detailGridInfo) => {
        detailGridInfo.api.setQuickFilter(null);
      });
    }

    if (existsInMaster) {
      gridApi.setQuickFilter(toFilterBy);
    } else {
      gridApi.setQuickFilter(toFilterBy);
      gridApi.forEachDetailGridInfo((detailGridInfo) => {
        detailGridInfo.api.setQuickFilter(toFilterBy);
      });
    }
    gridApi.refreshCells();
  };

  const onFilterTextBoxClear = () => {
    document.getElementById(`filter-text-box-${title.replaceAll(' ', '_')}`).value = '';
    gridApi.setQuickFilter('');
    gridApi.refreshCells();
    gridApi.setFilterModel(null);
    gridApi.onFilterChanged();
  };
  const getCustomContextMenuItems = () => {
    const arrContxtMenu = ['copy', 'copyWithHeaders', 'paste', 'export', 'chartRange'];
    return arrContxtMenu;
  };
  async function onBtExport() {
    if (!gridApi) return;
    function myColumnWidthCallback(params) {
      return params.column.getActualWidth();
    }

    function sanitizeString(str) {
      if (str === null || str === undefined) return '';
      return String(str).replace(/[\x00-\x08\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g, '');
    }

    function getCellClassString(colDef) {
      if (!colDef || !colDef.cellClass) return '';
      const cc = colDef.cellClass;
      if (Array.isArray(cc)) return cc.join(' ');
      return String(cc);
    }

    function formattingFunction(params) {
      try {
        if (!params) return '';
        const rawVal = params.value;

        if (rawVal === null || rawVal === undefined) {
          return '';
        }

        const colDef = params.column && params.column.colDef ? params.column.colDef : {};
        const cellClassStr = getCellClassString(colDef);

        if (rawVal instanceof Date) {
          try {
            const modDate = dateToNull(rawVal, 'dd-mmm-yy');
            return sanitizeString(String(modDate || ''));
          } catch (e) {
            return '';
          }
        }

        if (Array.isArray(rawVal)) {
          const parts = [];
          for (let i = 0; i < rawVal.length; i++) {
            const v = rawVal[i];
            if (v === null || v === undefined) continue;
            if (v instanceof Date) {
              try {
                const d = dateToNull(v, 'dd-mmm-yy');
                if (d) parts.push(String(d));
              } catch {
                // Skip invalid dates
              }
            } else {
              const str = String(v).trim();
              if (str) parts.push(str);
            }
          }
          return sanitizeString(parts.join(', '));
        }

        if (typeof rawVal === 'object' && rawVal !== null) {
          return '';
        }

        if (cellClassStr.includes('dateFormat')) {
          try {
            const modDate = dateToNull(rawVal, 'dd-mmm-yy');
            return sanitizeString(String(modDate || ''));
          } catch (e) {
            return '';
          }
        }

        if (cellClassStr.includes('pipeSeparated') && typeof rawVal === 'string') {
          const parts = rawVal
            .split('#| ')
            .map((p) => String(p || '').trim())
            .filter(Boolean);
          return sanitizeString(parts.join(' | '));
        }

        if (cellClassStr.includes('splitedData') && typeof rawVal === 'string') {
          const parts = rawVal
            .split('#| ')
            .map((p) => String(p || '').trim())
            .filter(Boolean);
          return sanitizeString(parts.join(', '));
        }

        let strValue = '';
        if (typeof rawVal === 'number') {
          if (isFinite(rawVal) && !isNaN(rawVal)) {
            strValue = String(rawVal);
          } else {
            return '';
          }
        } else if (typeof rawVal === 'boolean') {
          strValue = String(rawVal);
        } else if (typeof rawVal === 'string') {
          strValue = rawVal.trim();
          if (strValue === '') return '';
        } else {
          strValue = String(rawVal);
          if (strValue === 'null' || strValue === 'undefined' || strValue === '[object Object]') {
            return '';
          }
        }

        return sanitizeString(strValue);
      } catch (error) {
        return '';
      }
    }

    const headerRaw =
      pageTitle !== '' && pageTitle !== undefined
        ? pageTitle
        : getTitle(window.location.pathname, pageTitle !== '' && pageTitle !== undefined ? pageTitle : title);

    const headerValue = sanitizeString(headerRaw || '');

    const customHeader = headerValue
      ? [
          {
            cells: [
              {
                styleId: 'bigHeader',
                data: {
                  type: 'String',
                  value: headerValue,
                },
              },
            ],
          },
        ]
      : [];

    const appendRow = appendData && Array.isArray(appendData) && appendData.length > 0 ? [...appendData] : [];

    const FileNameExcel =
      title !== undefined && title !== '' ? `${title.replaceAll(' ', '_').replaceAll('/', '_')}.xlsx` : 'ag-grid.xlsx';
    const ExcelColumnsDynamic = gridApi
      .getColumnDefs()
      .filter((x) => x.hide !== true)
      .map((y) => y.colId);

    function safeFormattingFunction(params) {
      try {
        if (!params) return '';

        const field = params.column && params.column.colDef ? params.column.colDef.field : null;

        let rawValue = null;
        if (params.node && params.node.data && field) {
          rawValue = params.node.data[field];
        } else {
          rawValue = params.value;
        }

        if (rawValue && typeof rawValue === 'object' && !(rawValue instanceof Date) && !Array.isArray(rawValue)) {
          if (rawValue.$$typeof || rawValue.props) {
            return '';
          }
        }

        if (rawValue === null || rawValue === undefined) {
          return '';
        }

        const colDef = params.column && params.column.colDef ? params.column.colDef : {};
        const cellClassStr = getCellClassString(colDef);

        if (rawValue instanceof Date) {
          try {
            const modDate = dateToNull(rawValue, 'dd-mmm-yy');
            return sanitizeString(String(modDate || ''));
          } catch (e) {
            return '';
          }
        }

        if (Array.isArray(rawValue)) {
          const parts = rawValue
            .map((v) => {
              if (v === null || v === undefined) return '';
              if (v instanceof Date) {
                try {
                  return dateToNull(v, 'dd-mmm-yy') || '';
                } catch {
                  return '';
                }
              }
              return String(v).trim();
            })
            .filter(Boolean);
          return sanitizeString(parts.join(', '));
        }

        if (typeof rawValue === 'object' && rawValue !== null) {
          return '';
        }

        if (cellClassStr.includes('dateFormat')) {
          try {
            const modDate = dateToNull(rawValue, 'dd-mmm-yy');
            return sanitizeString(String(modDate || ''));
          } catch (e) {
            return '';
          }
        }

        if (cellClassStr.includes('splitedData') && typeof rawValue === 'string') {
          const parts = rawValue
            .split('#| ')
            .map((p) => String(p || '').trim())
            .filter(Boolean);
          return sanitizeString(parts.join(', '));
        }

        let strValue = '';
        if (typeof rawValue === 'number') {
          if (isFinite(rawValue) && !isNaN(rawValue)) {
            strValue = String(rawValue);
          } else {
            return '';
          }
        } else if (typeof rawValue === 'boolean') {
          strValue = String(rawValue);
        } else if (typeof rawValue === 'string') {
          strValue = rawValue.trim();
          if (strValue === '') return '';
        } else {
          strValue = String(rawValue);
          if (strValue === 'null' || strValue === 'undefined' || strValue === '[object Object]') {
            return '';
          }
        }

        return sanitizeString(strValue);
      } catch (error) {
        return '';
      }
    }

    // Helper function to flatten grouped columns to get all leaf columns
    function flattenColumns(columns, includeHidden = false) {
      const result = [];
      columns.forEach((col) => {
        if (col.children && col.children.length > 0) {
          // Recursively flatten children
          result.push(...flattenColumns(col.children, includeHidden));
        } else if (includeHidden || col.hide !== true) {
          // Include all columns if includeHidden is true, otherwise only visible ones
          result.push(col);
        }
      });
      return result;
    }

    // Helper function to extract parent groups and their children
    function extractColumnGroups(columns, includeHidden = false) {
      const groups = [];
      columns.forEach((col) => {
        if (col.children && col.children.length > 0) {
          const children = includeHidden ? col.children : col.children.filter((child) => child.hide !== true);
          if (children.length > 0) {
            groups.push({
              headerName: col.headerName || '',
              children: children,
            });
          }
        } else if (includeHidden || col.hide !== true) {
          // Column without children (standalone)
          groups.push({
            headerName: col.headerName || '',
            children: [col],
          });
        }
      });
      return groups;
    }

    try {
      const allRowData = [];
      const allNodes = [];
      const collectNode = (node) => {
        if (node.data) {
          allRowData.push(node.data);
          allNodes.push(node);
        }
      };
      // `forEachNodeAfterFilterAndSort` only works for the client-side row model; for
      // serverSide/infinite grids it is a no-op, which left the export with zero rows and
      // triggered the "No data to export" alert. Those models already apply filtering and
      // sorting on the server, so the loaded nodes are in the correct order for `forEachNode`.
      const isServerBackedModel =
        gridOptions?.rowModelType === 'serverSide' || gridOptions?.rowModelType === 'infinite';
      if (isServerBackedModel) {
        gridApi.forEachNode(collectNode);
      } else {
        gridApi.forEachNodeAfterFilterAndSort(collectNode);
      }

      if (allRowData.length === 0) {
        alert('No data to export');
        return;
      }
      let columnDefs = gridApi.getColumnDefs();

      const hasGroupedHeaders = columnDefs.some((col) => col.children && col.children.length > 0);

      // Include hidden columns in Excel export (they may contain data needed for export)
      let leafColumns = flattenColumns(columnDefs, true);

      // Apply column filtering
      if (gridOptions.excelVisibleColumnsOnly) {
        const displayedColIds = gridApi.getAllDisplayedColumns().map((column) => column.getColId());
        leafColumns = filterToDisplayedColumns(leafColumns, displayedColIds);
      } else if (!gridOptions.dynamicExcelColumns && gridOptions.selectedColumns) {
        leafColumns = leafColumns.filter((col) => gridOptions.selectedColumns.includes(col.colId || col.field));
      } else if (gridOptions.dynamicExcelColumns) {
        leafColumns = leafColumns.filter((col) => {
          const colId = col.colId || col.field;
          // Include if in ExcelColumnsDynamic OR if it has a field (hidden columns with data)
          return ExcelColumnsDynamic.includes(colId) || (col.field && col.field !== '');
        });
      }

      // Extract column groups for header structure (include hidden columns for Excel export)
      let columnGroups = hasGroupedHeaders ? extractColumnGroups(columnDefs, true) : null;

      // Filter column groups to only include groups that have visible leaf columns
      if (columnGroups) {
        columnGroups = columnGroups
          .map((group) => ({
            ...group,
            children: group.children.filter((child) => {
              const colId = child.colId || child.field;
              return leafColumns.some((leaf) => (leaf.colId || leaf.field) === colId);
            }),
          }))
          .filter((group) => group.children.length > 0);
      }

      const workbook = new ExcelJS.Workbook();
      workbook.creator = 'Insightia';
      workbook.created = new Date();
      const worksheet = workbook.addWorksheet('sheet1');

      // Calculate starting row
      let currentRow = 1;

      // Add title header if needed
      if (headerValue) {
        worksheet.mergeCells(currentRow, 1, currentRow, leafColumns.length);
        const headerCell = worksheet.getCell(currentRow, 1);
        headerCell.value = headerValue;
        headerCell.font = { size: 25, color: { argb: 'FF193d75' } };
        headerCell.alignment = { indent: 1 };
        worksheet.getRow(currentRow).height = 48;
        currentRow += 2; // Skip a row after title
      }

      // Add parent header row if we have grouped headers
      if (hasGroupedHeaders && columnGroups) {
        const parentHeaderRow = worksheet.getRow(currentRow);
        let colIndex = 1;

        columnGroups.forEach((group) => {
          const childCount = group.children.length;
          if (childCount > 0) {
            // Merge cells for parent header
            if (childCount > 1) {
              worksheet.mergeCells(currentRow, colIndex, currentRow, colIndex + childCount - 1);
            }
            const cell = parentHeaderRow.getCell(colIndex);
            cell.value = sanitizeString(String(group.headerName || ''));
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FF193d75' },
            };
            cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center', indent: 1 };
            cell.border = {
              top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
              left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
              bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
              right: { style: 'thin', color: { argb: 'FFCCCCCC' } },
            };
            colIndex += childCount;
          }
        });
        parentHeaderRow.height = 40;
        currentRow++;
      }

      // Add child header row (leaf column names)
      const childHeaderRow = worksheet.getRow(currentRow);
      leafColumns.forEach((colDef, index) => {
        const headerName = colDef.headerName || colDef.field || '';
        const cell = childHeaderRow.getCell(index + 1);
        cell.value = sanitizeString(String(headerName));
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF193d75' },
        };
        cell.alignment = { wrapText: true, vertical: 'middle', indent: 1 };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
          left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
          bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
          right: { style: 'thin', color: { argb: 'FFCCCCCC' } },
        };
      });
      childHeaderRow.height = 48;
      currentRow++;

      // Add data rows
      allRowData.forEach((rowData, rowIndex) => {
        const dataRow = worksheet.getRow(currentRow + rowIndex);
        const node = allNodes[rowIndex];
        leafColumns.forEach((colDef, colIndex) => {
          const field = colDef.colId || colDef.field;
          let cellValue = rowData[field];

          if (cellValue === undefined && colDef.colId && colDef.field && colDef.colId !== colDef.field) {
            if (rowData[colDef.field] !== undefined) {
              cellValue = rowData[colDef.field];
            } else if (rowData[colDef.colId] !== undefined) {
              cellValue = rowData[colDef.colId];
            }
          }
          if (cellValue === undefined && node) {
            try {
              const allColumns = gridApi.getColumns();
              let matchedColumn = null;

              if (allColumns) {
                matchedColumn = allColumns.find((col) => {
                  const colDefToMatch = col.getColDef();
                  if (colDef.headerName && colDefToMatch.headerName === colDef.headerName) {
                    return true;
                  }
                  if (colDef.colId && colDefToMatch.colId === colDef.colId) {
                    return true;
                  }
                  if (colDef.field && colDefToMatch.field === colDef.field) {
                    return true;
                  }
                  return false;
                });
              }

              if (matchedColumn) {
                cellValue = gridApi.getValue(matchedColumn, node);
              } else {
                const column = gridApi.getColumn(colDef.colId || colDef.field);
                if (column) {
                  cellValue = gridApi.getValue(column, node);
                }
              }
            } catch (e) {
              if (colDef.valueGetter && typeof colDef.valueGetter === 'function') {
                try {
                  const mockParams = {
                    data: rowData,
                    node: node,
                    api: gridApi,
                    columnApi: gridColumnApi,
                    context: {},
                    getValue: (fieldName) => rowData[fieldName],
                  };
                  cellValue = colDef.valueGetter(mockParams);
                } catch (e2) {
                  // Ignore errors
                }
              }
              if (cellValue === undefined && colDef.cellRenderer && typeof colDef.cellRenderer === 'function') {
                try {
                  const mockParams = {
                    data: rowData,
                    node: node,
                    api: gridApi,
                    columnApi: gridColumnApi,
                    context: {},
                    value: undefined,
                    getValue: (fieldName) => rowData[fieldName],
                  };
                  const rendererResult = colDef.cellRenderer(mockParams);
                  if (rendererResult !== null && rendererResult !== undefined) {
                    if (
                      typeof rendererResult === 'string' ||
                      typeof rendererResult === 'number' ||
                      typeof rendererResult === 'boolean'
                    ) {
                      cellValue = rendererResult;
                    } else if (
                      typeof rendererResult === 'object' &&
                      rendererResult.props &&
                      typeof rendererResult.props.children === 'string'
                    ) {
                      cellValue = rendererResult.props.children;
                    }
                  }
                } catch (e3) {
                  // Ignore errors
                }
              }
            }
          }

          const cellClassStr = getCellClassString(colDef);
          let isDateValue = false;
          let dateValue = null;

          const isValidDate = (d) => d instanceof Date && !isNaN(d);

          if (cellValue === null || cellValue === undefined) {
            cellValue = '';
          } else if (cellValue instanceof Date) {
            if (isValidDate(cellValue)) {
              isDateValue = true;
              dateValue = cellValue;
              cellValue = dateToNull(cellValue, 'dd-mmm-yy') || '';
            } else {
              cellValue = '';
            }
          } else if (cellClassStr.includes('dateFormat') && typeof cellValue !== 'number') {
            try {
              let parsedDate = null;
              if (cellValue instanceof Date) {
                parsedDate = cellValue;
              } else if (typeof cellValue === 'string') {
                const dateStr = cellValue.trim();
                if (dateStr) {
                  parsedDate = new Date(dateStr.replaceAll('/', '-'));
                }
              } else {
                parsedDate = new Date(cellValue);
              }

              if (parsedDate && isValidDate(parsedDate)) {
                isDateValue = true;
                dateValue = parsedDate;
                cellValue = parsedDate;
              } else {
                cellValue = dateToNull(cellValue, 'dd-mmm-yy') || '';
              }
            } catch (e) {
              cellValue = '';
            }
          } else if (Array.isArray(cellValue)) {
            cellValue = cellValue
              .map((v) => {
                if (v === null || v === undefined) return '';
                if (v instanceof Date) {
                  try {
                    return dateToNull(v, 'dd-mmm-yy') || '';
                  } catch {
                    return '';
                  }
                }
                return String(v).trim();
              })
              .filter(Boolean)
              .join(', ');
          } else if (typeof cellValue === 'object' && cellValue !== null) {
            cellValue = '';
          } else if (cellClassStr.includes('pipeSeparated') && typeof cellValue === 'string') {
            cellValue = cellValue
              .split('#| ')
              .map((p) => (p !== null && p !== undefined ? String(p).trim() : ''))
              .filter((p) => p !== '')
              .join(' | ');
          } else if (cellClassStr.includes('splitedData') && typeof cellValue === 'string') {
            cellValue = cellValue
              .split('#| ')
              .map((p) => (p !== null && p !== undefined ? String(p).trim() : ''))
              .filter((p) => p !== '')
              .join(', ');
          } else if (typeof cellValue === 'number') {
            if (!isFinite(cellValue) || isNaN(cellValue)) {
              cellValue = '';
            }
          } else if (typeof cellValue === 'boolean') {
            // Keep as boolean
          } else {
            // Convert to string and sanitize
            cellValue = sanitizeString(String(cellValue));
          }

          const cell = dataRow.getCell(colIndex + 1);

          if (isDateValue && dateValue instanceof Date) {
            cell.value = dateValue;
            cell.numFmt = 'dd-mmm-yy';
          } else if (typeof cellValue === 'number') {
            cell.value = cellValue;
          } else if (typeof cellValue === 'boolean') {
            cell.value = cellValue;
          } else {
            cell.value = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';
          }

          // Apply formatting
          const isEvenRow = rowIndex % 2 === 0;
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: isEvenRow ? 'FFF5F5F5' : 'FFFFFFFF' },
          };
          cell.alignment = { wrapText: true, vertical: 'middle', indent: 1 };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
            left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
            bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
            right: { style: 'thin', color: { argb: 'FFCCCCCC' } },
          };
        });
      });

      // Auto-size columns
      leafColumns.forEach((colDef, index) => {
        let maxLength = 10;
        worksheet.getColumn(index + 1).eachCell({ includeEmpty: true }, (cell) => {
          const cellLength = cell.value ? String(cell.value).length : 10;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });
        worksheet.getColumn(index + 1).width = Math.min(Math.max(maxLength, 10), 50);
      });

      // Generate blob and download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, FileNameExcel);
    } catch (error) {
      alert('An error occurred while exporting to Excel. Please try again.');
    }
  }

  const myExcelStyles = [
    {
      id: 'header',
      alignment: {
        wrapText: true,
        vertical: 'Center',
        indent: 1,
        shrinkToFit: true,
      },
      interior: {
        color: '#193d75',
        pattern: 'Solid',
      },
      font: { color: '#ffffff', bold: true },
      borders: {
        borderBottom: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderLeft: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderRight: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderTop: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
      },
    },
    {
      id: 'headerGroup',
      alignment: {
        shrinkToFit: true,
        wrapText: true,
      },
      interior: {
        color: '#193d75',
        pattern: 'Solid',
      },
      font: { color: '#ffffff', bold: true },
      borders: {
        borderBottom: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderLeft: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderRight: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderTop: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
      },
    },
    {
      id: 'booleanType',
      dataType: 'boolean',
    },

    {
      id: 'even',
      interior: {
        color: '#f5f5f5',
        pattern: 'Solid',
      },
      alignment: {
        wrapText: true,
        vertical: 'Center',
        indent: gridOptions.indent !== undefined ? gridOptions.indent : 1,
      },
      font: { color: '#181d1f', bold: false },
      borders: {
        borderBottom: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderLeft: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderRight: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderTop: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
      },
    },
    {
      id: 'odd',
      interior: {
        color: '#ffffff',
        pattern: 'Solid',
      },
      alignment: {
        wrapText: true,
        vertical: 'Center',
        indent: gridOptions.indent !== undefined ? gridOptions.indent : 1,
      },
      font: { color: '#181d1f', bold: false },
      borders: {
        borderBottom: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderLeft: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderRight: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderTop: {
          color: '#CCCCCC',
          lineStyle: 'Continuous',
          weight: 1,
        },
      },
    },
    {
      id: 'ws-normal-lh30',
      dataType: 'string',
      alignment: {
        wrapText: true,
        vertical: 'Center',
        indent: 1,
      },
    },
    {
      id: 'ws-normal-lh24',
      dataType: 'string',
      alignment: {
        wrapText: true,
        vertical: 'Center',
        indent: 1,
      },
    },
    {
      id: 'numberFormatXlS',
      numberFormat: {
        format: '#,##0',
      },
    },
    {
      id: 'decimalFormatXlS',
      numberFormat: {
        format: '#,##0.00',
      },
    },
    {
      id: 'dateFormat',
      dataType: 'DateTime',
      numberFormat: { format: 'dd-mmm-yy' },
    },
    {
      id: 'bigHeader',
      alignment: {
        indent: 1,
      },
      font: { color: '#193d75', size: 25 },
    },
    {
      id: 'redFont',
      font: {
        color: '#ff0000',
      },
    },
    {
      id: 'greenFont',
      font: {
        color: '#008000',
      },
    },
    {
      id: 'cellAlign',
      alignment: {
        horizontal: 'Left',
      },
    },
    {
      id: 'dodgerBlueFont',
      font: {
        color: '#1E90FF',
      },
    },
    {
      id: 'greyBackground',
      alignment: {
        horizontal: 'Right',
        vertical: 'Bottom',
      },
      borders: {
        borderBottom: {
          color: '#000000',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderLeft: {
          color: '#000000',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderRight: {
          color: '#000000',
          lineStyle: 'Continuous',
          weight: 1,
        },
        borderTop: {
          color: '#000000',
          lineStyle: 'Continuous',
          weight: 1,
        },
      },
      font: { color: '#e0ffc1' },
      interior: {
        color: '#cccccc',
        pattern: 'Solid',
      },
    },
    {
      id: 'hyperlinksExcelExport',
      dataType: 'Formula',
      font: {
        underline: 'Single',
        color: '#358ccb',
      },
    },
    {
      id: 'verticalHeader',
      interior: {
        color: '#193D75',
      },
      font: { color: '#FFFFFF' },
    },
  ];

  const refreshCache = () => {
    setServerButtonColour(false);
    updateRowData(gridParams);
    gridApi.refreshServerSide({ purge: true });
  };

  // If the data is updated by a function this ensures that the rowData is updated
  // controlled by the "dataUpdatesFX" gridoption
  if (gridOptions.dataUpdatesFX === true && gridApi && gridOptions.rowData.length !== 0) {
    gridApi.setGridOption('rowData', gridOptions.rowData);
  }
  return (
    <div key={key}>
      {query.print && query.print_new ? (
        <TablePDF
          IsShowCard={IsShowCard}
          cancelSlideBottomToUp={cancelSlideBottomToUp}
          isComp={isComp}
          isInvest={isInvest}
          title={title}
          extratitle={extratitle}
          smalltitle={smalltitle}
          addedClass={addedClass}
          isHeaderInfoTooltip={isHeaderInfoTooltip}
          gridOptions={gridOptions}
          isLandscape={isLandscape}
          repeatedColIndex={repeatedColIndex}
          limitedColumns={limitedColumns}
          isFullWidth={isFullWidth}
        />
      ) : (
        <Card
          IsShowCard={IsShowCard}
          cancelSlideBottomToUp={cancelSlideBottomToUp}
          isComp={isComp}
          isInvest={isInvest}
          title={title}
          extratitle={extratitle}
          smalltitle={smalltitle}
          addedClass={addedClass}
          isHeaderInfoTooltip={isHeaderInfoTooltip}
        >
          <ErrorBoundary>
            <div className="row p-0">
              {gridOptions.quickSearchFilter && gridOptions.quickSearchFilter !== undefined && (
                <div
                  className={
                    hideQuickFilter ? 'd-none' : 'col-xs-3 col-sm-3 col-md-3 col-lg-3 divFilterTable  mb-0 px-3 mx-2'
                  }
                >
                  <div className="row">
                    <div className="col-9">
                      {gridOptions.masterDetail ? (
                        <input
                          id={`filter-text-box-${title.replaceAll(' ', '_')}`}
                          type="text"
                          autoComplete="off"
                          className="form-control"
                          placeholder="Search..."
                          onInput={onMasterDetailFilterTextBoxChanged}
                        />
                      ) : (
                        <input
                          id={`filter-text-box-${title.replaceAll(' ', '_')}`}
                          type="text"
                          autoComplete="off"
                          className="form-control"
                          placeholder="Search..."
                          onInput={onFilterTextBoxChanged}
                          onChange={onFilterTextBoxChanged}
                        />
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-9">
                      <button type="button" className="btn btn-primary btn-sm w-100" onClick={onFilterTextBoxClear}>
                        Clear All Filters
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                {gridOptions.saveFilter === true && gridOptions.saveFilterParams && (
                  <div className="col-11">
                    <TableFilter
                      gridApi={gridApi}
                      gridOptions={gridOptions}
                      saveFilterParams={gridOptions.saveFilterParams}
                      defaultFilterList={gridOptions.defaultFilterList}
                      setServerButtonColour={setServerButtonColour}
                      filters={gridApi && gridApi.getFilterModel()}
                    />
                  </div>
                )}
                {gridOptions.refreshServer && (
                  <div className="col-1">
                    <button
                      type="button"
                      className={serverButtonColour ? 'btn btn-danger btn-sm btn-sm-danger' : 'btn btn-primary btn-sm'}
                      onClick={refreshCache}
                    >
                      Refresh Data
                    </button>
                  </div>
                )}
              </div>
              <div className="divShowHideTable">
                <div className="">
                  {gridOptions.hideReturnColumns !== undefined && gridOptions.showReturnColumns !== undefined && (
                    <div style={{ float: 'right' }}>
                      <div
                        className="btn btn-primary btn-sm btnShowHide col"
                        id="showReturnData"
                        onClick={() => (isHideReturnShowBtn ? onBtColReturnHide() : onBtColReturnShow())}
                      >
                        {isHideReturnShowBtn
                          ? gridOptions.showReturnColumns.btnName
                          : gridOptions.hideReturnColumns.btnName}
                      </div>
                    </div>
                  )}
                  {/* Show Hide Column */}
                  {gridOptions.hideColumns !== undefined && gridOptions.showColumns !== undefined && gridApi && (
                    <div style={{ float: 'right' }}>
                      <div
                        className="btn btn-primary btn-sm btnShowHide col"
                        id="showAllColumn"
                        onClick={toggleShowHideColumns}
                      >
                        {isHideShowBtn ? gridOptions.showColumns.btnName : gridOptions.hideColumns.btnName}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {gridOptions.colDefsMedalsExcluded.length !== 0 && (
                <button
                  type="button"
                  className="btn btn-primary m-1 btn-sm"
                  onClick={() => (toggleExcludeColumns ? onBtExcludeMedalColumns() : onBtIncludeMedalColumns())}
                >
                  {toggleExcludeColumns ? 'Exclude Medal Columns' : 'Include Medal Columns'}
                </button>
              )}
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 divShowHideTable mb-1 mt-2">
                {showInfoLable !== undefined && showInfoLable !== '' ? (
                  <label
                    className="lblInfo display-linebreak"
                    dangerouslySetInnerHTML={{
                      __html: showInfoLable,
                    }}
                  />
                ) : (
                  ''
                )}
                {linebreakInfoLable ? (
                  <label className="lblInfo display-linebreak text-danger">{linebreakInfoLable}</label>
                ) : (
                  ''
                )}
                {!query.print && isExpandAll && (
                  <button
                    type="button"
                    className="btn excelAdjust ag-excel float-start p-1"
                    onClick={() => {
                      updateRowExpanded();
                    }}
                  >
                    <u>{expandAll ? 'Close All' : 'Expand All'}</u>
                  </button>
                )}
                {!query.print && !hideExcelDownloadIcon && (
                  <button type="button" className="btn excelAdjust ag-excel float-end" onClick={() => onBtExport()}>
                    <u>{DOWNLOADXLS}</u>
                  </button>
                )}
              </div>
              {gridOptions.tableSmallLabel && gridOptions.tableSmallLabel !== undefined && (
                <div className="col-12 mb-0">
                  <p className={`${gridOptions.tableSmallLabelClassName ?? 'text-primary'} mb-0`}>
                    <small>{gridOptions.tableSmallLabel}</small>
                  </p>
                </div>
              )}
            </div>

            <div
              ref={gridContainerRef}
              id="grid"
              className={
                gridOptions.isTableHide && gridOptions.isTableHide !== undefined
                  ? bem.b('ag-theme-alpine d-tables d-none')
                  : bem.b('ag-theme-alpine d-tables')
              }
              style={{
                width: '100%',
                height: gridOptions.gridHeight !== undefined ? gridOptions.gridHeight : '100%',
              }}
            >
              {gridOptions.HeaderGrouping ? (
                gridOptions.HeaderGrouping.isHeaderChildren ? (
                  <AgGridReact
                    ref={topAgGrid}
                    isRowMaster={gridOptions.isRowMaster}
                    treeData={gridOptions.treeData}
                    getDataPath={gridOptions.getDataPath}
                    groupDisplayType={gridOptions.groupDisplayType}
                    groupDefaultExpanded={gridOptions.groupDefaultExpanded}
                    detailRowHeight={gridOptions.detailRowHeight}
                    suppressHorizontalScroll={gridOptions.suppressHorizontalScroll}
                    detailRowAutoHeight={gridOptions.detailRowAutoHeight}
                    getRowId={getRowId}
                    excelStyles={gridOptions.excelStyles !== undefined ? gridOptions.excelStyles : myExcelStyles}
                    getContextMenuItems={!gridOptions.noContextMenuItems ? getCustomContextMenuItems.bind(this) : []}
                    autoGroupColumnDef={gridOptions.autoGroupColumnDef}
                    groupUseEntireRow={gridOptions.groupUseEntireRow}
                    rowClassRules={gridOptions.rowClassRules}
                    groupSuppressAutoColumn={gridOptions.groupSuppressAutoColumn}
                    isExternalFilterPresent={isExternalFilterPresent}
                    components={gridComponents}
                    rowBuffer={gridOptions.rowBuffer}
                    rowSelection={gridOptions.rowSelection}
                    rowModelType={gridOptions?.rowModelType}
                    serverSideStoreType={
                      gridOptions.serverSideStoreType !== undefined ? gridOptions.serverSideStoreType : 'full'
                    }
                    cacheBlockSize={shouldUseCacheBlockSize ? (gridOptions.cacheBlockSize ?? 100000) : undefined}
                    paginationPageSize={
                      gridOptions.paginationPageSize !== undefined
                        ? gridOptions.paginationPageSize
                        : gridOptions.paggination.pageSize
                    }
                    cacheOverflowSize={gridOptions.cacheOverflowSize}
                    maxConcurrentDatasourceRequests={gridOptions.maxConcurrentDatasourceRequests}
                    infiniteInitialRowCount={gridOptions.infiniteInitialRowCount}
                    maxBlocksInCache={mainMaxBlocksInCache}
                    enableCellTextSelection={gridOptions.enableCellTextSelection}
                    domLayout={gridOptions.domLayout !== undefined ? gridOptions.domLayout : 'autoHeight'}
                    animateRows
                    rowData={gridOptions.rowData}
                    onGridReady={onGridReady.bind(this)}
                    getChartToolbarItems={getChartToolbarItems}
                    getRowHeight={safeGetRowHeight}
                    rowHeight={gridOptions.rowHeight}
                    groupHeaderHeight={gridOptions.HeaderGrouping.groupHeaderHeight}
                    headerHeight={gridOptions.headerHeight}
                    pagination={gridOptions.paggination.isPagging}
                    defaultColDef={defaultColDef}
                    getRowStyle={gridOptions.getRowStyle}
                    groupSuppressBlankHeader={gridOptions.groupSuppressBlankHeader}
                    groupAllowUnbalanced={gridOptions.groupAllowUnbalanced}
                    getRowClass={gridOptions.getRowClass}
                    rowClass={gridOptions.rowClass}
                    onGridSizeChanged={onGridSizeChanged.bind(this)}
                    cellFlashDuration={1000}
                    cellFadeDuration={500}
                    sideBar={gridOptions.sideBar}
                    pivotMode={gridOptions.pivotMode}
                    suppressAggFuncInHeader={gridOptions.suppressAggFuncInHeader}
                    statusBar={gridOptions.statusBar}
                    columnTypes={gridColumnTypes}
                    aggFuncs={gridAggFuncs}
                    onColumnResized={gridOptions.heightData !== undefined ? '' : headerHeightSetter}
                    popupParent={document.body}
                    enableCharts={gridOptions.enableCharts !== undefined ? gridOptions.enableCharts : false}
                    enableRangeSelection={
                      gridOptions.enableRangeSelection !== undefined ? gridOptions.enableRangeSelection : true
                    }
                    immutableData={gridOptions.immutableData !== undefined ? gridOptions.immutableData : false}
                    alignedGrids={[FooterAgGrid]}
                    masterDetail={gridOptions.masterDetail}
                    detailCellRendererParams={gridOptions.detailCellRendererParams}
                    getDetailRowData={gridOptions.getDetailRowData}
                    suppressRowTransform={
                      gridOptions.suppressRowTransform !== undefined ? gridOptions.suppressRowTransform : false
                    }
                    autoHeight={gridOptions.autoHeight !== undefined ? gridOptions.autoHeight : false}
                    wrapText={gridOptions.wrapText !== undefined ? gridOptions.wrapText : false}
                    suppressFieldDotNotation={
                      gridOptions.suppressFieldDotNotation !== undefined ? gridOptions.suppressFieldDotNotation : false
                    }
                    columnDefs={columnDefs}
                    paginationPageSizeSelector={false}
                  />
                ) : (
                  ''
                )
              ) : (
                <AgGridReact
                  enableColResize={true}
                  isRowMaster={gridOptions.isRowMaster}
                  treeData={gridOptions.treeData}
                  getDataPath={gridOptions.getDataPath}
                  groupDisplayType={gridOptions.groupDisplayType}
                  groupDefaultExpanded={gridOptions.groupDefaultExpanded}
                  masterDetail={gridOptions.masterDetail}
                  detailRowHeight={gridOptions.detailRowHeight}
                  suppressHorizontalScroll={gridOptions.suppressHorizontalScroll}
                  detailRowAutoHeight={gridOptions.detailRowAutoHeight}
                  getRowId={getRowId}
                  excelStyles={gridOptions.excelStyles !== undefined ? gridOptions.excelStyles : myExcelStyles}
                  ref={topAgGrid}
                  getContextMenuItems={!gridOptions.noContextMenuItems ? getCustomContextMenuItems.bind(this) : []}
                  enableCellTextSelection={gridOptions.enableCellTextSelection}
                  autoGroupColumnDef={gridOptions.autoGroupColumnDef}
                  groupUseEntireRow={gridOptions.groupUseEntireRow}
                  rowClassRules={gridOptions.rowClassRules}
                  groupSuppressAutoColumn={gridOptions.groupSuppressAutoColumn}
                  isExternalFilterPresent={isExternalFilterPresent}
                  components={gridComponents}
                  rowBuffer={gridOptions.rowBuffer}
                  rowSelection={gridOptions.rowSelection}
                  rowModelType={gridOptions?.rowModelType}
                  paginationPageSize={
                    gridOptions.paginationPageSize !== undefined
                      ? gridOptions.paginationPageSize
                      : gridOptions.paggination.pageSize
                  }
                  cacheOverflowSize={gridOptions.cacheOverflowSize}
                  maxConcurrentDatasourceRequests={gridOptions.maxConcurrentDatasourceRequests}
                  infiniteInitialRowCount={gridOptions.infiniteInitialRowCount}
                  maxBlocksInCache={mainMaxBlocksInCache}
                  domLayout={gridOptions.domLayout !== undefined ? gridOptions.domLayout : 'autoHeight'}
                  animateRows
                  rowData={gridOptions.rowData}
                  getRowHeight={safeGetRowHeight}
                  headerHeight={gridOptions.headerHeight}
                  rowHeight={gridOptions.rowHeight}
                  pagination={gridOptions.paggination.isPagging}
                  getRowStyle={gridOptions.getRowStyle}
                  groupSuppressBlankHeader={gridOptions.groupSuppressBlankHeader}
                  groupAllowUnbalanced={gridOptions.groupAllowUnbalanced}
                  getRowClass={gridOptions.getRowClass}
                  rowClass={gridOptions.rowClass}
                  onFirstDataRendered={onFirstDataRendered.bind(this)}
                  onGridSizeChanged={onGridSizeChanged.bind(this)}
                  defaultColDef={defaultColDef}
                  onGridReady={onGridReady.bind(this)}
                  getChartToolbarItems={getChartToolbarItems}
                  cellFlashDuration={1000}
                  cellFadeDuration={500}
                  sideBar={gridOptions.sideBar}
                  pivotMode={gridOptions.pivotMode}
                  suppressAggFuncInHeader={gridOptions.suppressAggFuncInHeader}
                  statusBar={gridOptions.statusBar}
                  columnTypes={gridColumnTypes}
                  aggFuncs={gridAggFuncs}
                  serverSideStoreType={
                    gridOptions.serverSideStoreType !== undefined ? gridOptions.serverSideStoreType : 'full'
                  }
                  cacheBlockSize={shouldUseCacheBlockSize ? (gridOptions.cacheBlockSize ?? 100000) : undefined}
                  onColumnResized={gridOptions.heightData !== undefined ? '' : headerHeightSetter}
                  popupParent={document.body}
                  enableCharts={gridOptions.enableCharts !== undefined ? gridOptions.enableCharts : false}
                  enableRangeSelection={
                    gridOptions.enableRangeSelection !== undefined ? gridOptions.enableRangeSelection : true
                  }
                  immutableData={gridOptions.immutableData !== undefined ? gridOptions.immutableData : false}
                  alignedGrids={[FooterAgGrid]}
                  detailCellRendererParams={gridOptions.detailCellRendererParams}
                  getDetailRowData={gridOptions.getDetailRowData}
                  suppressRowTransform={
                    gridOptions.suppressRowTransform !== undefined ? gridOptions.suppressRowTransform : false
                  }
                  autoHeight={gridOptions.autoHeight !== undefined ? gridOptions.autoHeight : false}
                  wrapText={gridOptions.wrapText !== undefined ? gridOptions.wrapText : false}
                  suppressFieldDotNotation={
                    gridOptions.suppressFieldDotNotation !== undefined ? gridOptions.suppressFieldDotNotation : false
                  }
                  columnDefs={columnDefs}
                  paginationPageSizeSelector={false}
                />
              )}
            </div>

            {isDropDown !== undefined && (
              <>
                <div className="row">
                  <div className="col mt-3 mb-3">
                    <DropdownList
                      handleChange={async (e) => {
                        if (e !== null) {
                          handledChangedDDLValue(e);
                          handleDropDown(e);
                        } else {
                          const eNull = { lable: 'Default', value: 0 };
                          handleDropDown(eNull);
                        }
                      }}
                      maxHeight={250}
                      options={isDropDown}
                      isMulti={false}
                      placeholder="Choose a pre-set trend to graph (Optional)"
                      Dvalue={DropDownSelection}
                    />
                  </div>
                </div>
                <div className="row" id="chartArea">
                  <div className="ag-theme-balhamm mb-3" id="myChart" />
                </div>
              </>
            )}
            {gridOptionsFooter && (
              <div
                ref={gridFooterContainerRef}
                id="grid-footer"
                className={bem.b('ag-theme-alpine d-tables')}
                style={{
                  width: '100%',
                  height: gridOptionsFooter.gridHeight !== undefined ? gridOptionsFooter.gridHeight : '45px',
                }}
              >
                <AgGridReact
                  components={gridFooterComponents}
                  rowBuffer={gridOptionsFooter.rowBuffer}
                  rowSelection={gridOptionsFooter.rowSelection}
                  rowModelType={gridOptionsFooter?.rowModelType}
                  suppressHorizontalScroll={gridOptionsFooter.suppressHorizontalScroll}
                  paginationPageSize={
                    gridOptionsFooter.paginationPageSize !== undefined
                      ? gridOptionsFooter.paginationPageSize
                      : gridOptionsFooter.paggination.pageSize
                  }
                  cacheOverflowSize={gridOptionsFooter.cacheOverflowSize}
                  maxConcurrentDatasourceRequests={gridOptionsFooter.maxConcurrentDatasourceRequests}
                  ref={FooterAgGrid}
                  infiniteInitialRowCount={gridOptionsFooter.infiniteInitialRowCount}
                  getRowId={footerGetRowId}
                  maxBlocksInCache={footerMaxBlocksInCache}
                  domLayout={gridOptionsFooter.domLayout !== undefined ? gridOptionsFooter.domLayout : 'normal'}
                  animateRows
                  rowData={gridOptionsFooter.rowData}
                  headerHeight={gridOptionsFooter.headerHeight}
                  getRowHeight={safeFooterGetRowHeight}
                  rowHeight={gridOptionsFooter.rowHeight}
                  pagination={gridOptionsFooter.paggination.isPagging}
                  getRowStyle={gridOptionsFooter.getRowStyle}
                  groupSuppressBlankHeader={gridOptionsFooter.groupSuppressBlankHeader}
                  groupAllowUnbalanced={gridOptionsFooter.groupAllowUnbalanced}
                  getRowClass={gridOptionsFooter.getRowClass}
                  rowClass={gridOptionsFooter.rowClass}
                  onFirstDataRendered={onFirstDataRenderedFooter.bind(this)}
                  onGridSizeChanged={onGridSizeChangedFooter.bind(this)}
                  defaultColDef={defaultColDefFooter}
                  onGridReady={onGridReadyFooter}
                  sideBar={gridOptionsFooter.sideBar}
                  pivotMode={gridOptionsFooter.pivotMode}
                  suppressAggFuncInHeader={gridOptionsFooter.suppressAggFuncInHeader}
                  statusBar={gridOptionsFooter.statusBar}
                  columnTypes={gridFooterColumnTypes}
                  aggFuncs={gridFooterAggFuncs}
                  alignedGrids={[topAgGrid]}
                  suppressFieldDotNotation={
                    gridOptionsFooter.suppressFieldDotNotation !== undefined
                      ? gridOptionsFooter.suppressFieldDotNotation
                      : false
                  }
                  columnDefs={footerColumnDefs}
                  paginationPageSizeSelector={false}
                />
              </div>
            )}
          </ErrorBoundary>
        </Card>
      )}
    </div>
  );
};
TableAgGridv31.propTypes = {
  IsShowCard: PropTypes.bool,
  addedClass: PropTypes.string,
  gridOptions: PropTypes.object.isRequired,
  gridOptionsFooter: PropTypes.object,
  hideExcelDownloadIcon: PropTypes.bool,
  isComp: PropTypes.bool,
  isInvest: PropTypes.bool,
  pageTitle: PropTypes.string,
  smalltitle: PropTypes.string,
  title: PropTypes.string,
  extratitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cancelSlideBottomToUp: PropTypes.bool,
  showInfoLable: PropTypes.any,
  linebreakInfoLable: PropTypes.any,
};

export default React.memo(TableAgGridv31);
